import React, { useEffect, useState } from "react";
import styles from "./ModalAmoIntegrationForm.module.scss";
import { Modal } from "../../ui/Modal/Modal";
import { useDispatch, useSelector } from "react-redux";
import {
  setActiveDataAmo,
  setNewDataAmo,
} from "../../store/slices/amoSlice";
import { useModal } from "../../context/ModalContext";
import {
  stepsDataAmo,
  stepsDataAmoApiUrl,
} from "../../assets/consts/tooltipDataAmo";
import { AmoCRMIcon } from "../../assets/icons/AmoCRMIcon";
import { ClipLoader } from "react-spinners";
import Button from "../../ui/Button/Button";
import Input from "../../ui/Input/Input";
import Title from "../../ui/Title/Title";
import { initAmo } from "../../utils/api/actions/integrations/amo";

const AmoSuccessMessage = ({ closeModal, closeAddIntegrationModal }) => {
  const [countdown, setCountdown] = useState(5);
  const dispatch = useDispatch();
  const id = localStorage.getItem("@storage_User_Id");

  useEffect(() => {
    const timer = setInterval(() => setCountdown((prev) => prev - 1), 1000);
    if (countdown === 0) {
      closeModal();
      closeAddIntegrationModal();
      dispatch(setActiveDataAmo(null));
      dispatch(setNewDataAmo(null));
    }
    return () => clearInterval(timer);
  }, [countdown, closeModal, dispatch, id, closeAddIntegrationModal]);

  return (
    <div className={styles.successMessage}>
      <h2>Вы успешно подключили AmoCRM!</h2>
      <div>
        <ClipLoader /> Окно закроется через {countdown} секунд.
      </div>
    </div>
  );
};

export const ModalAmoIntegrationForm = ({ visible, handlerClose }) => {
  const { closeModal } = useModal();
  const dispatch = useDispatch();
  const user = useSelector((state) => state?.user?.data);

  const [form, setForm] = useState({
    apiURL: "",
    secretKey: "",
    integrationId: "",
    token: "",
    name: "",
    description: "",
  });
  const [isAmoConnected, setIsAmoConnected] = useState(false);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleChange = (e) => {
    const { id, value } = e.target;
    setForm((prev) => ({ ...prev, [id]: value }));
  };

  const handleKeyDown = (e, field) => {
    if (e.key !== "Enter") return;
    e.preventDefault();

    const fields = [
      "secretKey",
      "integrationId",
      "token",
      "name",
      "description",
    ];
    const currentIndex = fields.indexOf(field);

    if (currentIndex < fields.length - 1) {
      document.getElementById(fields[currentIndex + 1])?.focus();
    } else if (fields.every((f) => form[f].trim() !== "")) {
      handleSendDataInitAmo();
    } else {
      setError("Заполните все поля");
    }
  };

  const handleSendDataInitAmo = () => {
    const data = { userId: user.id, ...form };
    dispatch(initAmo(data, setLoading, setIsAmoConnected));
  };

  const fields = [
    {
      id: "apiURL",
      label: "API URL",
      placeholder: "https://ваш_домен.amocrm.ru",
      hint: { id: "amoURL", stepsData: stepsDataAmoApiUrl },
    },
    {
      id: "secretKey",
      label: "Секретный ключ",
      placeholder: "Секретный ключ",
      hint: { id: "amo", stepsData: stepsDataAmo },
    },
    {
      id: "integrationId",
      label: "Id интеграции",
      placeholder: "Id интеграции",
    },
    {
      id: "token",
      label: "Токен",
      placeholder: "Токен",
    },
    {
      id: "name",
      label: "Название интеграции",
      placeholder: "Название",
    },
    {
      id: "description",
      label: "Описание интеграции",
      placeholder: "Описание",
    },
  ];

  return (
    <Modal
      styleClose={styles.closeIcon}
      visible={visible}
      handleClose={handlerClose}
    >
      <div className={styles.container}>
        <div className={styles.header}>
          <Title title="Новая интеграция" className={styles.title} />
          <AmoCRMIcon />
        </div>
        {isAmoConnected ? (
          <AmoSuccessMessage
            closeModal={handlerClose}
            closeAddIntegrationModal={closeModal}
          />
        ) : (
          <div className={styles.form}>
            {fields.map(({ id, label, placeholder, hint }) => (
              <div className={styles.inputContainer} key={id}>
                <Input
                  id={id}
                  onKeyPress={(e) => handleKeyDown(e, id)}
                  className={styles.child}
                  label={label}
                  labelStyle={styles.labelInput}
                  backgroundStyle={styles.labelBackground}
                  inputStyle={`${styles.input} ${error ? styles.error : ""}`}
                  value={form[id]}
                  placeholder={placeholder}
                  type="text"
                  onChange={handleChange}
                  hint={hint}
                />
                {error && <div className={styles.errorMessage}>{error}</div>}
              </div>
            ))}
            <Button
              onClick={handleSendDataInitAmo}
              className={styles.button}
              titleClassName={styles.buttonTitle}
              leftIcon={loading ? <ClipLoader size={16} color="white" /> : null}
              title={loading ? "Подождите" : "Отправить"}
            />
          </div>
        )}
      </div>
    </Modal>
  );
};
